import {Enum} from "library-js/class";

export const State = new Enum("idle", "saving", "deleting", "error");
State.domains.editable = [State.idle, State.error];

export const STARS_STYLES = {
	icons: "AntDesign/star",
	offStyle: {color: "#e4e4e4"},
};
